import React from "react";
import { Button, Result } from "antd";
import { Link } from "react-router-dom";
import PageRoutes from "../../utils/routes";

const Unauthorized = () => {
  const handleGoBack = () => {
    window.history.back(); // Tarayıcı geçmişini kullanarak bir önceki sayfaya dön
  };

  return (
    <Result
      status="403"
      title="Erişim Yok"
      subTitle="Bu sayfaya erişiminiz bulunmamaktadır."
      extra={
        <div>
          <Button type="default" onClick={handleGoBack}>
            Geri Dön
          </Button>
          <div style={{ width: "10px", display: "inline-block" }} />
          <Link to={PageRoutes.home}>
            <Button type="primary">Ana Sayfa</Button>
          </Link>
        </div>
      }
    />
  );
};

export default Unauthorized;
